import {connect} from "react-redux";
import CreateTask from "./create";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {saveTask, getAssignee, getAccount, getOpportunityByAccountId, getTaskTypes} from "../../../service/Task/action";

const mapStateToProps = (state) => ({
    taskType:state.Task.getTaskType,
    assignee:state.Task.assignee,
    accountsDetails:state.Task.getAccounts,
    saveTaskDetails:state.Task.saveTask,
    opportunityDetails:state.Task.opportunityDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveTask,
            documentUploadUrlPublic,
            getAssignee,
            getAccount,
            getOpportunityByAccountId,
            getTaskTypes
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CreateTask);
